import { IComposedFilterForSave } from 'legacy/lut/features/partner360/composedReport'
import { ITranslateFn, safeTranslations } from 'legacy/lut/helpers/safeTranslations'

interface IGetStringWithTranslatedKeys {
  data: IComposedFilterForSave
  key: string
  t: ITranslateFn
}

export const getStringWithTranslatedKeys = ({ data, key, t }: IGetStringWithTranslatedKeys) => {
  if (Array.isArray(data[key])) {
    return data[key].map((el: string) => safeTranslations(el, t)).join(',')
  }
  return ''
}
